import { FBTrackingEvent } from '../Utility/Tracking/FBTrackingEvent';

export const ASOLILevelEventsMap = new Map<number, FBTrackingEvent>([
    [5, FBTrackingEvent.ASOLI_Lvl05_Complete],
    [10, FBTrackingEvent.ASOLI_Lvl10_Complete],
    [15, FBTrackingEvent.ASOLI_Lvl15_Complete],
    [20, FBTrackingEvent.ASOLI_Lvl20_Complete],
    [40, FBTrackingEvent.ASOLI_Lvl40_Complete],
    [80, FBTrackingEvent.ASOLI_Lvl80_Complete],
    [160, FBTrackingEvent.ASOLI_Lvl160_Complete],
    [240, FBTrackingEvent.ASOLI_Lvl240_Complete],
    [320, FBTrackingEvent.ASOLI_Lvl320_Complete],
    [400, FBTrackingEvent.ASOLI_Lvl400_Complete],
    [480, FBTrackingEvent.ASOLI_Lvl480_Complete],
    [560, FBTrackingEvent.ASOLI_Lvl560_Complete],
]);

export const ASOLIWorldEvents = [
    FBTrackingEvent.ASOLI_UserEnter_Austria,
    FBTrackingEvent.ASOLI_UserEnter_Bali,
    FBTrackingEvent.ASOLI_UserEnter_Italy,
    FBTrackingEvent.ASOLI_UserEnter_Japan,
    FBTrackingEvent.ASOLI_UserEnter_Iceland,
    FBTrackingEvent.ASOLI_UserEnter_Australia,
    FBTrackingEvent.ASOLI_UserEnter_Egypt,
    FBTrackingEvent.ASOLI_UserEnter_Arizona,
    FBTrackingEvent.ASOLI_UserEnter_Paris,
    FBTrackingEvent.ASOLI_UserEnter_Tanzania,
    FBTrackingEvent.ASOLI_UserEnter_Berlin,
    FBTrackingEvent.ASOLI_UserEnter_Cambodia,
    FBTrackingEvent.ASOLI_UserEnter_England,
    FBTrackingEvent.ASOLI_UserEnter_Canada,
    FBTrackingEvent.ASOLI_UserEnter_Brazil,
    FBTrackingEvent.ASOLI_UserEnter_Russia,
];

export const AdjustTokens = new Map<FBTrackingEvent, string>([
    [FBTrackingEvent.FTUE_03_GamefieldIsShow, 'l7kces'],
    [FBTrackingEvent.FTUE_05_FirstCardClear, '5mfj3z'],
    [FBTrackingEvent.FTUE_06_Level01FinishWindowShow, 'erwkfu'],
    [FBTrackingEvent.FTUE_07_TapOnButtonContinue, 'jnf43y'],
    [FBTrackingEvent.FTUE_10a_Level2PreLevelButtonPlay, 'fzzq8t'],
    [FBTrackingEvent.FTUE_11_Gamefield2IsShow, '9lm0ev'],
    [FBTrackingEvent.FTUE_15_Level02FinishWindowShow, 'u1btgs'],
    [FBTrackingEvent.FTUE_20a_Level3PreLevelButtonPlay, 'gb9lc1'],
    [FBTrackingEvent.FTUE_21_Gamefield3IsShow, 'm9xvqc'],
    [FBTrackingEvent.FTUE_23_Level03FinishWindowShow, 'dezsev'],
    [FBTrackingEvent.VideoAdWatchFiveCards, '22ljgl'],
    [FBTrackingEvent.VideoAdWatchGetCoins, '819ghn'],
    [FBTrackingEvent.VideoAdWatchWheel, 'z5cvxm'],
    [FBTrackingEvent.VideoAdWatchGetLife, 'cvh9iw'],
    [FBTrackingEvent.VideoAdWatchSkipMission, 'wfy52g'],
    [FBTrackingEvent.VideoAdWatch_3star_present, '7bcoia'],
    [FBTrackingEvent.RewardedAdRequested, 'q08tjy'],
    [FBTrackingEvent.RewardedAdDisplayed, 'kdi6dw'],
    [FBTrackingEvent.VideoAdCannotBeDisplayedFillrate, '4klxhk'],
    [FBTrackingEvent.InterstitialAdRequested, 'drel52'],
    [FBTrackingEvent.InterstitialAdDisplayed, 'ger38o'],
    [FBTrackingEvent.TapOnBuyFiveCards, '8m1o7f'],
    [FBTrackingEvent.TapOnUndoMove, 'zhwdqr'],
    [FBTrackingEvent.TapOnJokerCard, 'x0nxqz'],
    [FBTrackingEvent.TapOnBullsEye, 'sipoev'],
    [FBTrackingEvent.TapOnTNT, 'tgof14'],
    [FBTrackingEvent.TapOnShuffle, 'p1hah1'],
    [FBTrackingEvent.BuyLifeCoins, 'rdt4py'],
    [FBTrackingEvent.three_star_window_show, 'jr0cm5'],
    [FBTrackingEvent.Mission_Complete, 'uvox53'],
    [FBTrackingEvent.TapOnWheelLife, 'unxy8k'],
    [FBTrackingEvent.Level4_GameFieldShow, 'osejuo'],
    [FBTrackingEvent.Level5_GameFieldShow, '6juukm'],
    [FBTrackingEvent.Level6_GameFieldShow, 'upifqu'],
    [FBTrackingEvent.Level7_GameFieldShow, '6k80mu'],
    [FBTrackingEvent.Level8_GameFieldShow, 'idd7u6'],
    [FBTrackingEvent.Level9_GameFieldShow, '28d88c'],
    [FBTrackingEvent.Level10_GameFieldShow, 'kff1rg'],
    [FBTrackingEvent.Level4_WinScreenShow, 'wjcq10'],
    [FBTrackingEvent.Level5_WinScreenShow, 'etvy68'],
    [FBTrackingEvent.Level6_WinScreenShow, '6j2ymb'],
    [FBTrackingEvent.Level7_WinScreenShow, 'oiymeh'],
    [FBTrackingEvent.Level8_WinScreenShow, 'rgscpo'],
    [FBTrackingEvent.Level9_WinScreenShow, '69l7fq'],
    [FBTrackingEvent.Level10_WinScreenShow, '24bbtq'],
    [FBTrackingEvent.Product007_Start, 'kbmnmc'],
    [FBTrackingEvent.Product008_Start, '9a4pta'],
    [FBTrackingEvent.Product009_Start, 'k447hz'],
    [FBTrackingEvent.Product010_Start, 'eh3kho'],
    [FBTrackingEvent.Product011_Start, 'lctsmj'],
    [FBTrackingEvent.Product012_Start, 'rxbe7r'],
    [FBTrackingEvent.Product007_Success, 'vk3hwr'],
    [FBTrackingEvent.Product008_Success, 'y4idv3'],
    [FBTrackingEvent.Product009_Success, '6zpinh'],
    [FBTrackingEvent.Product010_Success, '9c8425'],
    [FBTrackingEvent.Product011_Success, '3r29je'],
    [FBTrackingEvent.Product012_Success, '73opk0'],
    [FBTrackingEvent.Product007_Fail, 'udakoq'],
    [FBTrackingEvent.Product008_Fail, 'shyyy6'],
    [FBTrackingEvent.Product009_Fail, 'fgivi1'],
    [FBTrackingEvent.Product010_Fail, 'tw926x'],
    [FBTrackingEvent.Product011_Fail, 'r8sdl5'],
    [FBTrackingEvent.Product012_Fail, 'uy74km'],
    [FBTrackingEvent.ASOLI_Lvl05_Complete, 'jujyb1'],
    [FBTrackingEvent.ASOLI_Lvl10_Complete, 'i2kn9q'],
    [FBTrackingEvent.ASOLI_Lvl15_Complete, 'd1t8dl'],
    [FBTrackingEvent.ASOLI_Lvl20_Complete, 'slc5e8'],
    [FBTrackingEvent.ASOLI_Lvl40_Complete, '3z531z'],
    [FBTrackingEvent.ASOLI_Lvl80_Complete, 'u2gthe'],
    [FBTrackingEvent.ASOLI_Lvl160_Complete, '26y7tf'],
    [FBTrackingEvent.ASOLI_Lvl240_Complete, '830dgr'],
    [FBTrackingEvent.ASOLI_Lvl320_Complete, 'jk85wv'],
    [FBTrackingEvent.ASOLI_Lvl400_Complete, 'ego43y'],
    [FBTrackingEvent.ASOLI_Lvl480_Complete, 'lykwd4'],
    [FBTrackingEvent.ASOLI_Lvl560_Complete, 'tmk6nm'],
    [FBTrackingEvent.ASOLI_UserEnter_Austria, 'b320sk'],
    [FBTrackingEvent.ASOLI_UserEnter_Bali, 'qdgne9'],
    [FBTrackingEvent.ASOLI_UserEnter_Italy, 'mqjkpf'],
    [FBTrackingEvent.ASOLI_UserEnter_Japan, 'lv7jkc'],
    [FBTrackingEvent.ASOLI_UserEnter_Iceland, '6z25hp'],
    [FBTrackingEvent.ASOLI_UserEnter_Australia, 'pqe1bb'],
    [FBTrackingEvent.ASOLI_UserEnter_Egypt, 'att7b1'],
    [FBTrackingEvent.ASOLI_UserEnter_Arizona, 'lhe6nv'],
    [FBTrackingEvent.ASOLI_UserEnter_Paris, 'v8qw0y'],
    [FBTrackingEvent.ASOLI_UserEnter_Tanzania, 'ebdh1t'],
    [FBTrackingEvent.ASOLI_UserEnter_Berlin, 'yki286'],
    [FBTrackingEvent.ASOLI_UserEnter_Cambodia, 's86zko'],
    [FBTrackingEvent.ASOLI_UserEnter_England, '23e0uk'],
    [FBTrackingEvent.ASOLI_UserEnter_Canada, 'yhqzt4'],
    [FBTrackingEvent.ASOLI_UserEnter_Brazil, 'p6ff16'],
    [FBTrackingEvent.ASOLI_UserEnter_Russia, 'o8e8cn'],
]);
